import { TOOLTIPS } from 'app/constants/TOOLTIPS';
import { GridHeaderWithPopoverSearchComponent } from './data-widgets/grid-header-with-popover-search.component';
import { GridHeaderWithTooltipComponent } from './data-widgets/grid-header-with-tooltip.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { RankGradeComponent } from './data-widgets/rank-grade.component';
import { RatingPillComponent } from './data-widgets/rating-pill.component';
import { ReportConfig } from './REPORT_CONFIG';
import { BigNumberDataComponent } from './data-widgets/big-number-data.component';
import { SellerRegionComponent } from './data-widgets/seller-region.component';
import { CountryComponent } from './data-widgets/country.component';
import { CTV_STI_OPTIONS } from './REPORT_CONFIG_CONST';
import { SellerRiskComponent } from './data-widgets/seller-risks.component';
import { SellerNameComponent } from './data-widgets/seller-name.component';
import { PercentDataWithZeroComponent } from './data-widgets/percent-data-with-zero.component';
import { GridHeader } from './models/gridHeader';

export const COMMON_SELLER_CONFIG_HEADERS: GridHeader[] = [
  {
    label: 'Arbitraged Inventory Ratio',
    key: 'arbitrageInventoryRatio',
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.arbitrageInventoryRatio
    }
  },
  {
    label: '‘DIRECT’ Publisher Penetration',
    key: 'directPublisherPenetration',
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: BigNumberDataComponent,
    format: 'pretty-number',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.directPublisherPenetration,
      domain: TOOLTIPS.directPublisherPenetrationDomain
    }
  },
  {
    label: 'SIVT Ratio',
    key: 'sivtRatio',
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.sivtRatio
    }
  },
  {
    label: 'GIVT Ratio',
    key: 'givtRatio',
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.givtRatio
    }
  },
  {
    label: 'Delisted App Traffic Ratio',
    key: 'delistedAppTrafficRatio',
    groups: ['app'],
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.delistedAppTrafficRatio
    }
  },
  {
    label: 'MFA App Traffic Ratio',
    key: 'mfaAppTrafficRatio',
    groups: ['app'],
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.mfaAppTrafficRatio
    }
  },
  {
    label: 'Fraudulent Bundle ID Traffic Ratio',
    key: 'fraudulentBundleRatio',
    groups: ['ctv'],
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.fraudulentBundleRatio
    }
  },
  {
    label: 'MFA Domain Traffic Ratio',
    key: 'mfaDomainTrafficRatio',
    groups: ['domain'],
    sort: '',
    sortDefault: false,
    sortColumnKey: null,
    hoverKey: '',
    template: null,
    widgetComponent: PercentDataWithZeroComponent,
    format: '1.0',
    hidden: false,
    lockIfAnonymous: true,
    lockIfFreemium: true,
    headerWidgetComponent: GridHeaderWithTooltipComponent,
    tooltipText: {
      default: TOOLTIPS.mfaDomainTrafficRatio
    }
  }
];

export const REPORT_CONFIG_SELLER_TRUST_INDEX: ReportConfig = {
  key: 'seller-trust-index',
  heading: 'Seller Trust Index 2.0',
  title: 'Seller Trust Index 2.0',
  formTitle: 'Seller Trust Index',
  pageTitle:
    'Seller Trust Index 2.0 - Quality Seller Rankings for the Programmatic Supply Chain',
  pageMeta:
    'Seller Trust Index 2.0, a Pixalate Rankings index, is the rating standard for measuring seller quality across {type}',
  reportId: 'sellerTrustIndex',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  cta: {
    anonHeading: 'Unlock Full Rankings:',
    freemiumHeading: 'Unlock Full Scores',
    showAll: true
  },
  rowLimit: 1000,
  fadeStart: 1000,
  sortable: true,
  notHideDataIfNA: true,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: CTV_STI_OPTIONS[0],
      groups: ['ctv'],
      hidden: false,
      type: 'toggle-filter',
      options: [...CTV_STI_OPTIONS]
    },
    {
      key: 'region',
      label: 'Region',
      selected: { label: 'US', value: 'US' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          key: 'platformName'
        }
      ],
      options: [
        { label: 'US', value: 'US' },
        { label: 'NON-US', value: 'NON-US' }
      ],
      default: { label: 'North America', value: 'NA' }
    },
    {
      key: 'countryCode',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          group: 'ctv',
          key: 'platformName'
        },
        {
          key: 'date'
        },
        {
          label: 'Region'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'United States', value: 'US' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'rank',
      sort: '',
      sortDefault: false,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      hidden: false,
      widgetComponent: RankDataComponent,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Seller Name',
      key: 'sellerName',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: SellerNameComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithPopoverSearchComponent
    },
    {
      label: 'Final Score',
      key: 'finalScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Market Share Score',
      key: 'marketShareScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.marketShareScore,
        ctv: TOOLTIPS.marketShareScore,
        domain: TOOLTIPS.marketShareScore
      }
    },
    {
      label: 'SPO Score',
      key: 'spoOptimizationScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.spoOptimizationScore,
        ctv: TOOLTIPS.spoOptimizationScore,
        domain: TOOLTIPS.spoOptimizationScore
      }
    },
    {
      label: 'SCO Verification Score',
      key: 'scoVerificationScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.scoVerificationScore,
        ctv: TOOLTIPS.scoVerificationScore,
        domain: TOOLTIPS.scoVerificationScore
      }
    },
    {
      label: 'Bundle Integrity',
      key: 'bundleIntegrityScore',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        ctv: `Represents the amount of traffic from the seller that uses standardized app store IDs in the bid stream.`
      }
    },
    {
      label: 'Reach Score',
      key: 'reachScore',
      groups: ['app', 'domain'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'SIVT Score',
      key: 'sivtScore',
      groups: ['app', 'domain'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.sivtScore,
        domain: TOOLTIPS.sivtScore
      }
    },
    {
      label: 'GIVT Score',
      key: 'givtScore',
      groups: ['app', 'domain'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.givtScore,
        domain: TOOLTIPS.givtScore
      }
    },
    {
      label: 'Transparency Score',
      key: 'transparencyScore',
      groups: ['app'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Location Score',
      key: 'locationScore',
      groups: ['app'],
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'IVT Score',
      key: 'ivtScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        ctv: `Reflects the levels of Invalid Traffic (IVT) on the impressions associated with the seller.`
      }
    },
    {
      label: 'Household Score',
      key: 'householdScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Channel Share Score',
      key: 'channelShareScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'SSAI Score',
      key: 'ssaiScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Spoofing Score',
      key: 'spoofingScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Sideloaded Score',
      key: 'sideloadedScore',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent,
      showIfReq: {
        isFilter: {
          platform: 'firetv'
        }
      }
    },
    {
      label: 'Ads.txt Score',
      key: 'adsTxtScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Masking Score',
      key: 'maskingScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'MFA Risk Score',
      key: 'mfaRiskScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RatingPillComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.mfaRiskScore,
        domain: TOOLTIPS.mfaRiskScore
      }
    },
    {
      label: 'Viewability Score',
      key: 'viewabilityScore',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Website Count',
      key: 'websiteCount',
      sort: '',
      groups: ['domain'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: BigNumberDataComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Delisted App Risk Score (Beta)',
      key: 'delistedImpressionsScore',
      sort: '',
      groups: ['app'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: RankGradeComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent,
      tooltipText: {
        app: TOOLTIPS.delistedAppRiskScore
      }
    },

    /**
     * The columns below are newly added for Q3 2025.
     */
    {
      label: 'Risks',
      key: 'arbitrageInventoryRatio', // temporary use this key to force UI to show this column
      disableSort: true,
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: SellerRiskComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderWithTooltipComponent
    },
    ...COMMON_SELLER_CONFIG_HEADERS
  ]
};

export const SELLER_REPORT_CONFIG: ReportConfig[] = [
  {
    key: 'seller-trust-index',
    heading: 'Filtered by Seller',
    title: 'Filtered by Seller',
    reportId: 'sellerTrustIndex',
    permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
    sortable: true,
    notHideDataIfNA: true,
    mainFilterItems: [],
    gridHeaders: [
      {
        label: 'Region',
        key: 'parentRegion',
        sort: '',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        widgetComponent: SellerRegionComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderComponent
      },
      {
        label: 'Country',
        key: 'countryName',
        sort: '',
        sortDefault: false,
        sortColumnKey: null,
        hoverKey: '',
        template: null,
        widgetComponent: CountryComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderComponent
      },
      {
        label: 'Rank',
        key: 'rank',
        sort: '',
        sortDefault: false,
        sortColumnKey: '',
        hoverKey: '',
        template: null,
        hidden: false,
        widgetComponent: RankDataComponent,
        headerWidgetComponent: GridHeaderComponent
      },
      ...COMMON_SELLER_CONFIG_HEADERS
    ]
  }
];
